module.exports = __webpack_public_path__ + "static/media/agpoint.ac5162c0.svg";